<template>
    <tr>
        <td>
            <button v-if="isAdmin && checkIfEditEnabled" class="button is-primary" @click="updateItem" :disabled="isLocked">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="isAdmin && !checkIfEditEnabled" class="button" @click="editItem" :disabled="isLocked">
                <i class="fas fa-edit"></i>
            </button>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.name"></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="name" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.color"></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="color" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.displacement"></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="displacement" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.result"></span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="result" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.commission }}</span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="commission" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.auction_fee }}</span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="auction_fee" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.inland_transport }}</span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="inland_transport" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.discount }}</span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="discount" :disabled="isLocked"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.total }}</span>
            <input class="input" @keyup="calculateTotal" v-if="checkIfEditEnabled" v-model="total" :disabled="isLocked"/>
        </td>
        <td>
            <button class="button is-danger" v-if="index > 0" @click="deleteItem" :disabled="isLocked">
                <i class="fas fa-trash"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props:['item', 'index'],
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            checkIfEditEnabled() {
                return this.$store.getters.getProformaInvoiceSelectedSaleItem.id === this.item.id
            },
            name: {
                get() {
                   return this.$store.getters.getProformaInvoiceSelectedSaleItem.name
                },
                set(value) {
                   this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'name', value: value})
                }
            },
            color: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.color
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'color', value: value})
                }
            },
            displacement: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.displacement
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'displacement', value: value})
                }
            },
            result: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.result
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'result', value: value})
                }
            },
            commission: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.commission
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'commission', value: value})
                }
            },
            auction_fee: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.auction_fee
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'auction_fee', value: value})
                }
            },
            inland_transport: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.inland_transport
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'inland_transport', value: value})
                }
            },
            discount: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.discount
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'discount', value: value})
                }
            },
            total: {
                get() {
                    return this.$store.getters.getProformaInvoiceSelectedSaleItem.total
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceSelectedSaleItemFieldValue', { field: 'total', value: value})
                }
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        },
        methods: {
            calculateTotal() {
                this.total = Number(this.result) + Number(this.commission) + Number(this.auction_fee) + Number(this.inland_transport) - this.discount
            },
            editItem() {
                this.$store.dispatch('changeProformaInvoiceSelectedSaleItem', this.item)
                this.$store.dispatch('changeProformaInvoiceSelectedSaleItemIndex', this.index)
            },
            updateItem() {
                this.$store.dispatch('updateProformaInvoiceSaleItem')
                this.$store.dispatch('changeProformaInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateProformaInvoice')
            },
            deleteItem() {
                this.$store.dispatch('deleteProformaInvoiceSaleItem', this.item)
                this.$store.dispatch('changeProformaInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateProformaInvoice')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSalesTableRow.vue